interface MetricCardProps {
  name: string;
  baseline: number | null;
  current30d: number | null;
  delta: number | null;
}

function deltaColor(delta: number | null): string {
  if (delta === null) return 'bg-gray-100 text-gray-600';
  if (delta <= 0) return 'bg-green-100 text-green-700';
  if (delta <= 10) return 'bg-yellow-100 text-yellow-700';
  return 'bg-red-100 text-red-700';
}

function fmt(v: number | null): string {
  if (v === null) return '—';
  return v.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function MetricCard({ name, baseline, current30d, delta }: MetricCardProps) {
  const arrow = delta === null ? '' : delta > 0 ? '↑' : delta < 0 ? '↓' : '→';
  const colorCls = deltaColor(delta);

  return (
    <div className="bg-white border rounded-lg p-4 flex flex-col gap-2">
      <div className="text-sm font-medium text-gray-700">{name}</div>
      <div className="flex items-end gap-3">
        <div>
          <div className="text-xs text-gray-400">Baseline</div>
          <div className="text-lg font-semibold">{fmt(baseline)}</div>
        </div>
        <div>
          <div className="text-xs text-gray-400">Last 30d</div>
          <div className="text-lg font-semibold">{fmt(current30d)}</div>
        </div>
        {delta !== null && (
          <span className={`ml-auto inline-block px-2 py-0.5 rounded-full text-xs font-medium ${colorCls}`}>
            {arrow} {fmt(Math.abs(delta))}
          </span>
        )}
      </div>
    </div>
  );
}
